import { Button, Spin, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { ModalWarningIcon } from 'src/assets/icons'
import { LoadingOutlined } from '@ant-design/icons'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import './index.scss'

interface IProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  Username: string
  isLoading?: boolean
  isLocked?: boolean
}

const ConfirmModal = (props: IProps) => {
  const { isOpen, onClose, onConfirm, Username = '', isLoading = false, isLocked = false } = props
  const { t } = useTranslation()

  return (
    <ActionConfirmationModal
      icon={<ModalWarningIcon />}
      title={<Typography className='modal-title'>{t('ClientUserSetup:modal.confirmation')}</Typography>}
      onClose={onClose}
      isOpen={isOpen}
      descriptionType='string'
      description={
        <RichTextField
          richText={
            Username
              ? t('ClientUserSetup:modal.redirectContent', { Username })
              : isLocked
              ? t('ClientUserSetup:modal.warningContent', { Username })
              : t('ClientUserSetup:modal.confirmContent', { Username })
          }
        />
      }
      footer={[
        <Button size='middle' onClick={onClose} key={'no'}>
          {t('common:no')}
        </Button>,
        <Button size='middle' type='primary' onClick={onConfirm} key={'yes'}>
          {isLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    color: 'white',
                  }}
                />
              }
            />
          ) : (
            t('common:yes')
          )}
        </Button>,
      ]}
    />
  )
}

export default ConfirmModal
